import { DateOptions, IConfiguredTrafficReport } from "./IConfiguredTrafficReport";
import { AggregationPeriod } from "@app/shared";
import { downloadFacilityUsageCSV, GetFacilityUsageDataLoader } from "./FacilityUsageDataLoader";
import { formatInTimeZone } from "date-fns-tz";

function getMonthName(timezone:string, periodStart: Date, locale = 'en-US') {
    return formatInTimeZone(periodStart, timezone, 'MMMM');
}

export const FacilityUsageByMonth = {
    name: "by Month",
    description: "This report shows the total Inbound/Outbound Targets in the Location by month for the specified range ",
    component: GetFacilityUsageDataLoader(AggregationPeriod.Month, getMonthName),
    downloadData: opts => downloadFacilityUsageCSV(AggregationPeriod.Month, opts),
    defaultChartType: 'bar',
    defaultRange: DateOptions.ThisYear,
    key: 'fum',
    config: {
        requiresMonth: false,
        allowsCustomRange: true,
        requiresYear: false,
        allowTargetTypeGrouping: true,
        disabled: false,
        disallowChartTypeToggling: true
    }
} as IConfiguredTrafficReport;